import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { sanitizeHtml } from "utils/sanitizeHtml";

export function StatementIframe({ disclosures }) {
  const { height, ref } = useGetContentHeight(disclosures);

  return (
    <IFrame
      className="w-100 border-0 screen-height-60px overflow-y-hidden"
      style={{ height }}
      title="disclosures"
      scrolling="no"
    >
      <p ref={ref} className="p-2" dangerouslySetInnerHTML={{ __html: sanitizeHtml(disclosures) }} />
    </IFrame>
  );
}

export function IFrame({ children, ...props }) {
  const [contentRef, setContentRef] = useState(null);
  const mountNode = contentRef?.contentWindow?.document?.body;

  return (
    <iframe {...props} ref={setContentRef} title="disclosures">
      {mountNode && createPortal(children, mountNode)}
    </iframe>
  );
}

const useGetContentHeight = (disclosures) => {
  const ref = React.useRef();
  const [height, setHeight] = React.useState("");

  useEffect(() => {
    const _height = ref?.current?.scrollHeight + 15;
    if (_height) setHeight(_height);
  }, [disclosures]);

  return { height, ref };
};
